<script lang="ts" setup>
    import { __ } from '@/js/stores/expressions';
    import TextInput, { TextInputWidth } from '../TextInput.vue';
    import ScheduleFormsTable from './table/ScheduleFormsTable.vue';
    import { useScheduleCoachingFormTableStore } from '@/js/stores/schedule-coaching-form-table';
    import ScheduleCoaching from '../interactions/scheduleCoaching/ScheduleCoaching.vue';
    import { SearchIcon } from '@lucide/vue';

    const scheduleCoachingFormTableStore = useScheduleCoachingFormTableStore();
</script>
<template>
    <div class="pb-12">
        <TextInput
            :model-value="scheduleCoachingFormTableStore.searchTerm ?? ''"
            :width="TextInputWidth.Large"
            :placeholder="__('schedule-coaching-forms-search-placeholder')"
            @update:model-value="
                scheduleCoachingFormTableStore.searchTerm = $event?.toString() ?? ''
            "
        >
            <template #end-adornment><SearchIcon /></template>
        </TextInput>
    </div>

    <ScheduleFormsTable />

    <ScheduleCoaching />
</template>
